import React from "react";
import logo from "../../../../src/resources/sparksLogoBlue2.png";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footContainer">
      <div className="footInner">

        <div className="footMain">

          <a href="/">
            <img src={logo} alt="Sparks Psychological Services logo" className="footerLogo"/>
          </a>

          <div className="quickLinksWrapper">
            <h1>Quick Links</h1>

            <div className="quickLinksGrid">
              
              <ul>
                <li><a href="#forensic">Forensic Evaluations</a></li>
                <li><a href="#psych">Psychological Testing</a></li>
                <li><a href="#trainings">Trainings</a></li>
                <li><a href="#psychotherapy">Psychotherapy</a></li>
              </ul>

              <ul>
                <li><a href="#team">Our Team</a></li>
                <li><a href="#contact">Reach Us</a></li>
                <li><a href="/terms-of-service">Terms of Service</a></li>
                <li><a href="/privacy-policy">Privacy Policy</a></li>
                <li><a href="/cookie-policy">Cookie Policy</a></li>
              </ul>

            </div>
          </div>

        </div>

        <div className="footerBottom">
          Copyright © {new Date().getFullYear()}, Sparks Psychological Services, LLC
        </div>

      </div>
    </footer>
  );
}
